import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 md:p-4 border-b border-gray-100 dark:border-gray-600 flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-2 md:gap-3 flex-1 min-w-0" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "text-sm font-normal text-gray-900 dark:text-white truncate" }
const _hoisted_7 = { class: "flex items-center gap-1 md:gap-2" }
const _hoisted_8 = { class: "text-xs text-gray-500 dark:text-gray-400 hidden md:inline" }
const _hoisted_9 = { class: "text-xs text-gray-500 dark:text-gray-400 md:hidden" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400 hidden sm:inline truncate"
}
const _hoisted_11 = {
  key: 0,
  class: "flex items-center gap-1 md:gap-3 flex-shrink-0"
}
const _hoisted_12 = { class: "hidden md:flex items-center gap-2" }
const _hoisted_13 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "material-symbols-outlined text-sm" }
const _hoisted_22 = { class: "hidden sm:inline" }
const _hoisted_23 = {
  class: "trezo-card-content flex flex-col flex-grow overflow-hidden",
  style: {"min-height":"0"}
}
const _hoisted_24 = {
  class: "chat-body overflow-y-auto ltr:-mr-[10px] rtl:-ml-[10px] flex flex-col",
  style: {"flex":"1","min-height":"0"}
}
const _hoisted_25 = { class: "flex-1 p-4 space-y-4" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = {
  key: 0,
  class: "flex items-center justify-center h-32 bg-gray-100 dark:bg-gray-700"
}
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_33 = { class: "flex items-center gap-3" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_36 = {
  key: 1,
  class: "material-symbols-outlined"
}
const _hoisted_37 = { class: "flex-1 flex items-center gap-1" }
const _hoisted_38 = ["id", "src", "onLoadedmetadata", "onTimeupdate", "onEnded"]
const _hoisted_39 = { class: "flex justify-between items-center mt-2" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "flex-1 min-w-0" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["onClick", "title"]
const _hoisted_44 = {
  key: 0,
  class: "flex items-center gap-2 text-gray-400 px-4 pb-2"
}
const _hoisted_45 = { class: "text-xs" }
const _hoisted_46 = { class: "border-t border-gray-100 dark:border-gray-600 flex flex-col" }
const _hoisted_47 = { class: "p-4 pb-2" }
const _hoisted_48 = { class: "flex items-end gap-3" }
const _hoisted_49 = { class: "flex-1 relative" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = {
  key: 0,
  class: "emoji-picker absolute bottom-full right-0 mb-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg shadow-lg p-3 w-64 z-50"
}
const _hoisted_52 = { class: "grid-cols-8 gap-1 max-h-48 overflow-y-auto" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_56 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_57 = {
  key: 0,
  class: "p-4 pt-0"
}
const _hoisted_58 = { class: "bg-gray-50 dark:bg-gray-800 rounded-lg p-3 border border-gray-200 dark:border-gray-600" }
const _hoisted_59 = { class: "flex items-center justify-between mb-2" }
const _hoisted_60 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_61 = { class: "space-y-2" }
const _hoisted_62 = { class: "flex items-center gap-2" }
const _hoisted_63 = { class: "w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center" }
const _hoisted_64 = { class: "material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm" }
const _hoisted_65 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100 truncate max-w-40" }
const _hoisted_66 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "px-4 pt-0 mt-auto bg-gray-25 dark:bg-gray-850 hidden md:block" }
const _hoisted_69 = { class: "flex items-center gap-4" }
const _hoisted_70 = {
  class: "text-xs text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 flex items-center gap-1 relative group",
  title: "Coming Soon"
}
const _hoisted_71 = {
  class: "text-xs text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 flex items-center gap-1 relative group",
  title: "Coming Soon"
}
const _hoisted_72 = {
  class: "text-xs text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 flex items-center gap-1 relative group",
  title: "Coming Soon"
}
const _hoisted_73 = { class: "flex items-center gap-4" }
const _hoisted_74 = { class: "w-12 h-12 rounded-full overflow-hidden" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "text-lg font-semibold text-white" }
const _hoisted_77 = {
  key: 0,
  class: "text-sm text-white/80"
}
const _hoisted_78 = { class: "space-y-4" }
const _hoisted_79 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_80 = { class: "bg-gray-50 dark:bg-[#172036] rounded-xl p-3 text-sm" }
const _hoisted_81 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_82 = ["rows", "placeholder"]
const _hoisted_83 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_84 = ["rows", "placeholder"]
const _hoisted_85 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_86 = { value: "" }
const _hoisted_87 = { value: "general" }
const _hoisted_88 = { value: "products" }
const _hoisted_89 = { value: "services" }
const _hoisted_90 = { value: "support" }
const _hoisted_91 = { value: "billing" }
const _hoisted_92 = { value: "technical" }
const _hoisted_93 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_94 = ["rows", "placeholder"]
const _hoisted_95 = {
  key: 1,
  class: "fixed inset-0 z-50 flex items-center justify-center px-4"
}
const _hoisted_96 = { class: "relative bg-white dark:bg-[#0c1427] rounded-2xl w-full max-w-lg shadow-xl transform transition-all" }
const _hoisted_97 = { class: "p-6 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_98 = { class: "flex items-center gap-4" }
const _hoisted_99 = { class: "w-12 h-12 rounded-full overflow-hidden" }
const _hoisted_100 = ["src"]
const _hoisted_101 = { class: "text-lg font-semibold text-black dark:text-white" }
const _hoisted_102 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_103 = { class: "p-6" }
const _hoisted_104 = { class: "mb-4" }
const _hoisted_105 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_106 = { class: "relative" }
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "mb-4" }
const _hoisted_109 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_110 = ["placeholder"]
const _hoisted_111 = { class: "mb-6" }
const _hoisted_112 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_113 = { class: "flex gap-2" }
const _hoisted_114 = ["onClick"]
const _hoisted_115 = { class: "p-6 border-t border-gray-100 dark:border-[#172036] flex justify-end gap-3" }
const _hoisted_116 = { class: "p-4 text-center border-b border-gray-200 dark:border-[#172036] bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30" }
const _hoisted_117 = { class: "flex items-center gap-3 mb-1" }
const _hoisted_118 = { class: "text-lg font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent dark:from-blue-400 dark:to-indigo-400" }
const _hoisted_119 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_120 = {
  key: 0,
  class: "px-4 py-3 border-b border-gray-200 dark:border-[#172036] bg-green-50 dark:bg-green-900/20"
}
const _hoisted_121 = { class: "flex items-center gap-2" }
const _hoisted_122 = { class: "text-sm text-gray-600 dark:text-gray-300" }
const _hoisted_123 = { class: "font-semibold text-green-700 dark:text-green-400" }
const _hoisted_124 = { class: "max-h-80 overflow-y-auto py-2" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = { class: "flex-1" }
const _hoisted_127 = { class: "font-medium text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400" }
const _hoisted_128 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_129 = { class: "flex-1" }
const _hoisted_130 = { class: "font-medium text-red-600 dark:text-red-400 group-hover:text-red-700 dark:group-hover:text-red-300" }
const _hoisted_131 = { class: "text-xs text-red-500 dark:text-red-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["trezo-card chat-panel-enhanced mb-0 p-[8px] md:p-[10px] rounded-md flex flex-col h-full", {
      'bot-chat': _ctx.isBotChat,
      'bg-yellow-50/80 dark:bg-yellow-900/20': _ctx.isBotChat
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isMobile || _ctx.isBotChat)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isBotChat ? _ctx.backToCustomerChat() : _ctx.backToList())),
                class: "inline-block transition-all hover:text-primary-500 text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300 flex-shrink-0",
                "aria-label": _ctx.isBotChat ? 'חזרה לשיחה' : _ctx.directT('chat.backToList')
              }, _cache[33] || (_cache[33] = [
                _createElementVNode("i", { class: "material-symbols-outlined !text-xl" }, " arrow_back ", -1)
              ]), 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _ctx.isBotChat ? _ctx.currentBotImage : (_ctx.chatUser.profile_picture_url || _ctx.chatUser.image),
            alt: "user-image",
            class: "h-8 w-8 md:h-10 md:w-10 rounded-full flex-shrink-0",
            onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
          }, null, 40, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.isBotChat ? 'Bot Feedback Chat' : (_ctx.chatUser.name || _ctx.chatUser.phone)), 1),
            _createElementVNode("div", _hoisted_7, [
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "w-2 h-2 bg-success-500 rounded-full flex-shrink-0" }, null, -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.isBotChat ? 'Bot Response Feedback Chat' : 'Online'), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isBotChat ? 'Bot Chat' : 'Online'), 1),
              (!_ctx.isBotChat && _ctx.chatUser.phone && _ctx.chatUser.name && _ctx.chatUser.name !== _ctx.chatUser.phone)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, " • " + _toDisplayString(_ctx.chatUser.phone), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (!_ctx.isBotChat)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.directT('chat.bot')) + ":", 1),
                _createElementVNode("button", {
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full transition-colors", {
              'bg-primary-600': _ctx.chatUser.botstatus === true,
              'bg-gray-300 dark:bg-gray-600': _ctx.chatUser.botstatus !== true
            }]),
                  title: _ctx.chatUser.botstatus === true ? _ctx.directT('chat.botStatus.active') : _ctx.directT('chat.botStatus.inactive'),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleBotStatus && _ctx.toggleBotStatus(...args)))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-block h-4 w-4 transform rounded-full bg-white transition", {
                'ltr:translate-x-6 rtl:-translate-x-6': _ctx.chatUser.botstatus === true,
                'ltr:translate-x-1 rtl:-translate-x-1': _ctx.chatUser.botstatus !== true
              }])
                  }, null, 2)
                ], 10, _hoisted_14)
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(["md:hidden p-1 rounded text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300", {
            'text-primary-600 dark:text-primary-400': _ctx.chatUser.botstatus === true
          }]),
                title: _ctx.chatUser.botstatus === true ? _ctx.directT('chat.botStatus.active') : _ctx.directT('chat.botStatus.inactive'),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleBotStatus && _ctx.toggleBotStatus(...args)))
              }, _cache[35] || (_cache[35] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "smart_toy", -1)
              ]), 10, _hoisted_15),
              _createElementVNode("select", {
                class: "hidden md:block text-xs border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100",
                value: _ctx.assignedToId || '',
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAssignmentChange($event)))
              }, [
                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.directT('chat.assignment.assignTo')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgUsers, (user) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: user.user_id,
                    value: user.user_id
                  }, _toDisplayString(user.display_name), 9, _hoisted_18))
                }), 128))
              ], 40, _hoisted_16),
              _createElementVNode("button", {
                class: _normalizeClass(["md:hidden p-1 rounded text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300", {
            'text-blue-600 dark:text-blue-400': _ctx.assignedToId
          }]),
                title: _ctx.directT('chat.assignment.assignTo')
              }, _cache[36] || (_cache[36] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-lg" }, "person", -1)
              ]), 10, _hoisted_19),
              _createElementVNode("button", {
                class: _normalizeClass(["px-2 md:px-3 py-1 md:py-1.5 text-xs rounded-lg font-medium hover:opacity-80 transition-opacity flex items-center gap-1", {
            'bg-success-50 text-success-600 dark:bg-success-900/30 dark:text-success-400': _ctx.isChatOpen,
            'bg-gray-50 text-gray-600 dark:bg-gray-700 dark:text-gray-400': !_ctx.isChatOpen
          }]),
                title: _ctx.isChatOpen ? _ctx.directT('chat.chatStatus.open') : _ctx.directT('chat.chatStatus.closed'),
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleChatStatus && _ctx.toggleChatStatus(...args)))
              }, [
                _createElementVNode("i", _hoisted_21, _toDisplayString(_ctx.isChatOpen ? 'check' : 'close'), 1),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.isChatOpen ? _ctx.directT('chat.closeChat') : _ctx.directT('chat.openChat')), 1)
              ], 10, _hoisted_20)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "border-t border-gray-100 dark:border-[#172036] mt-[0px] mb-[0px]" }, null, -1)),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMessages, (message, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["flex items-start gap-3", { 
              'justify-end': message.from_our_customer,
              'flex-row-reverse': !message.from_our_customer 
            }])
              }, [
                _createElementVNode("img", {
                  src: message.from_our_customer ? _ctx.currentUserImage : (message.is_feedback ? _ctx.currentBotImage : (_ctx.chatUser.profile_picture_url || _ctx.chatUser.image)),
                  alt: "user",
                  class: "h-8 w-8 rounded-full flex-shrink-0",
                  onError: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_26),
                _createElementVNode("div", {
                  class: _normalizeClass({ 'flex-1': message.from_our_customer })
                }, [
                  (message.type === 'text')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["rounded-lg p-3", {
                  'bg-primary-600 text-white max-w-md ml-auto': message.from_our_customer,
                  'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100 max-w-md': !message.from_our_customer
                }])
                      }, [
                        _createElementVNode("div", {
                          innerHTML: _ctx.formatMessageText(message.text)
                        }, null, 8, _hoisted_27),
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-xs mt-1 opacity-70", {
                    'text-white/70': message.from_our_customer,
                    'text-gray-500 dark:text-gray-400': !message.from_our_customer
                  }])
                        }, _toDisplayString(_ctx.formatTime(message.created_at)), 3)
                      ], 2))
                    : _createCommentVNode("", true),
                  (message.type === 'photo' || message.type === 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["photo-message", { 'max-w-xs md:max-w-md': !message.from_our_customer, 'max-w-xs md:max-w-md ml-auto': message.from_our_customer }])
                      }, [
                        _createElementVNode("div", {
                          class: "photo-container cursor-pointer relative overflow-hidden rounded-lg",
                          onClick: ($event: any) => (_ctx.openImageInNewTab(message.link || message.media_url || message.text))
                        }, [
                          _createElementVNode("img", {
                            src: message.link || message.media_url || message.text,
                            alt: _ctx.directT('chat.photo'),
                            class: "w-full max-w-[200px] md:max-w-xs max-h-[250px] md:max-h-[300px] object-cover rounded-lg",
                            onError: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                            loading: "lazy"
                          }, null, 40, _hoisted_29),
                          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "absolute inset-0 bg-black/20 opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center" }, [
                            _createElementVNode("div", { class: "bg-white/90 rounded-full p-2" }, [
                              _createElementVNode("i", { class: "material-symbols-outlined text-gray-600" }, "open_in_new")
                            ])
                          ], -1)),
                          (!message.link && !message.media_url && !message.text)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _cache[37] || (_cache[37] = _createElementVNode("i", { class: "material-symbols-outlined text-3xl text-gray-400 dark:text-gray-500 mb-2" }, "image", -1)),
                                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.directT('chat.loadingPhoto')), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_28),
                        (message.caption)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: _normalizeClass(["mt-2 p-2 rounded text-sm", {
                    'bg-primary-500 text-white': message.from_our_customer,
                    'bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100': !message.from_our_customer
                  }])
                            }, _toDisplayString(message.caption), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-xs mt-2 opacity-70 text-center", {
                    'text-gray-600 dark:text-gray-400': true
                  }])
                        }, _toDisplayString(_ctx.formatTime(message.created_at)), 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (message.type === 'audio' || message.type === 'voice')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["audio-message", { 'max-w-md': !message.from_our_customer, 'max-w-md ml-auto': message.from_our_customer }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["audio-container rounded-lg p-3", {
                    'bg-primary-600': message.from_our_customer,
                    'bg-gray-100 dark:bg-gray-700': !message.from_our_customer
                  }])
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.toggleAudioPlay(message.id)),
                              class: _normalizeClass(["flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center", {
                        'bg-white/20 text-white hover:bg-white/30': message.from_our_customer,
                        'bg-gray-200 text-gray-600 hover:bg-gray-300 dark:bg-gray-600 dark:text-gray-300 dark:hover:bg-gray-500': !message.from_our_customer
                      }])
                            }, [
                              (!_ctx.audioStates[message.id]?.isPlaying)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_35, " play_arrow "))
                                : (_openBlock(), _createElementBlock("i", _hoisted_36, " pause "))
                            ], 10, _hoisted_34),
                            _createElementVNode("div", _hoisted_37, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
                                return _createElementVNode("div", {
                                  key: i,
                                  class: _normalizeClass(["w-1 rounded-full transition-all duration-150", {
                          'bg-white/70': message.from_our_customer,
                          'bg-gray-400 dark:bg-gray-500': !message.from_our_customer,
                          'bg-white': message.from_our_customer && _ctx.audioStates[message.id]?.currentBar >= i,
                          'bg-gray-600 dark:bg-gray-300': !message.from_our_customer && _ctx.audioStates[message.id]?.currentBar >= i
                        }]),
                                  style: _normalizeStyle({ height: Math.random() * 20 + 8 + 'px' })
                                }, null, 6)
                              }), 64))
                            ]),
                            _createElementVNode("audio", {
                              id: `audio-${message.id}`,
                              src: message.link || message.media_url || message.text,
                              preload: "metadata",
                              onLoadedmetadata: ($event: any) => (_ctx.onAudioLoaded(message.id, $event)),
                              onTimeupdate: ($event: any) => (_ctx.onAudioTimeUpdate(message.id, $event)),
                              onEnded: ($event: any) => (_ctx.onAudioEnded(message.id)),
                              style: {"display":"none"}
                            }, null, 40, _hoisted_38)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-xs", {
                        'text-white/80': message.from_our_customer,
                        'text-gray-500 dark:text-gray-400': !message.from_our_customer,
                        'order-1': message.from_our_customer,
                        'order-2': !message.from_our_customer
                      }])
                            }, _toDisplayString(_ctx.formatAudioDuration(message.duration || _ctx.audioStates[message.id]?.duration || 0)), 3),
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-xs opacity-70", {
                        'text-white/70': message.from_our_customer,
                        'text-gray-500 dark:text-gray-400': !message.from_our_customer,
                        'order-2': message.from_our_customer,
                        'order-1': !message.from_our_customer
                      }])
                            }, _toDisplayString(_ctx.formatTime(message.created_at)), 3)
                          ]),
                          (message.caption)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: _normalizeClass(["mt-2 text-sm", {
                      'text-white': message.from_our_customer,
                      'text-gray-700 dark:text-gray-300': !message.from_our_customer
                    }])
                              }, _toDisplayString(message.caption), 3))
                            : _createCommentVNode("", true)
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  (message.type === 'file' || message.type === 'document')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: _normalizeClass(["file-message", { 'max-w-md': !message.from_our_customer, 'max-w-md ml-auto': message.from_our_customer }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["file-container rounded-lg p-3", {
                    'bg-primary-600': message.from_our_customer,
                    'bg-gray-100 dark:bg-gray-700': !message.from_our_customer
                  }])
                        }, [
                          _createElementVNode("div", {
                            class: "flex items-center gap-3 cursor-pointer",
                            onClick: ($event: any) => (_ctx.downloadFile(message.media_url || message.link || message.text, message.filename))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center", {
                        'bg-white/20': message.from_our_customer,
                        'bg-gray-200 dark:bg-gray-600': !message.from_our_customer
                      }])
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["material-symbols-outlined text-2xl", {
                          'text-white': message.from_our_customer,
                          'text-gray-600 dark:text-gray-300': !message.from_our_customer
                        }])
                              }, _toDisplayString(_ctx.getFileIconFromUrl(message.media_url || message.link || message.text, message.filename)), 3)
                            ], 2),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("p", {
                                class: _normalizeClass(["text-sm font-medium truncate", {
                          'text-white': message.from_our_customer,
                          'text-gray-900 dark:text-gray-100': !message.from_our_customer
                        }])
                              }, _toDisplayString(_ctx.getFileNameFromUrl(message.media_url || message.link || message.text, message.filename)), 3),
                              _createElementVNode("p", {
                                class: _normalizeClass(["text-xs opacity-70", {
                          'text-white/70': message.from_our_customer,
                          'text-gray-500 dark:text-gray-400': !message.from_our_customer
                        }])
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.getFileTypeFromUrl(message.media_url || message.link || message.text, message.filename)) + " ", 1),
                                (message.filesize)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, " • " + _toDisplayString(_ctx.formatFileSize(message.filesize)), 1))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center", {
                        'bg-white/20': message.from_our_customer,
                        'bg-gray-200 dark:bg-gray-600': !message.from_our_customer
                      }])
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["material-symbols-outlined text-sm", {
                          'text-white': message.from_our_customer,
                          'text-gray-600 dark:text-gray-300': !message.from_our_customer
                        }])
                              }, " download ", 2)
                            ], 2)
                          ], 8, _hoisted_40),
                          (message.text && message.text.trim() && message.text !== (message.media_url || message.link))
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: _normalizeClass(["mt-2 text-sm", {
                      'text-white': message.from_our_customer,
                      'text-gray-700 dark:text-gray-300': !message.from_our_customer
                    }])
                              }, _toDisplayString(message.text), 3))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", {
                            class: _normalizeClass(["text-xs mt-2 opacity-70", {
                      'text-white/70': message.from_our_customer,
                      'text-gray-500 dark:text-gray-400': !message.from_our_customer,
                      'text-right': message.from_our_customer,
                      'text-left': !message.from_our_customer
                    }])
                          }, _toDisplayString(_ctx.formatTime(message.created_at)), 3)
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  (!message.from_our_customer && !message.is_feedback)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        onClick: ($event: any) => (_ctx.openFeedbackModal(message)),
                        class: "mt-2 opacity-0 group-hover:opacity-100 transition-opacity text-xs text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 flex items-center gap-1",
                        title: _ctx.directT('chat.botFeedback.addToKnowledge')
                      }, [
                        _cache[39] || (_cache[39] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "psychology", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('chat.botFeedback.trainBot')), 1)
                      ], 8, _hoisted_43))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2))
            }), 128))
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "flex space-x-1" }, [
                  _createElementVNode("div", { class: "w-2 h-2 bg-gray-400 rounded-full animate-bounce" }),
                  _createElementVNode("div", {
                    class: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                    style: {"animation-delay":"0.1s"}
                  }),
                  _createElementVNode("div", {
                    class: "w-2 h-2 bg-gray-400 rounded-full animate-bounce",
                    style: {"animation-delay":"0.2s"}
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.directT('chat.typing') || 'Typing...'), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", {
                class: "text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300 pb-3 relative group",
                title: "צרף קבצים",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args)))
              }, [
                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "material-symbols-outlined" }, "attach_file", -1)),
                _createElementVNode("input", {
                  ref: "fileInput",
                  type: "file",
                  multiple: "",
                  accept: "image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar",
                  class: "hidden",
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                }, null, 544)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _withDirectives(_createElementVNode("textarea", {
                  placeholder: _ctx.isBotChat ? _ctx.directT('chat.botFeedback.writeFeedbackPlaceholder') : _ctx.directT('chat.writeMessage'),
                  class: "w-full pl-4 pr-12 py-3 border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder:text-gray-500 dark:placeholder:text-gray-400 resize-none h-[50px] max-h-[120px]",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.inputText) = $event)),
                  onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.isBotChat ? _ctx.sendBotFeedback() : _ctx.sendMessage()), ["prevent"])),
                  onKeydown: _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.isBotChat ? _ctx.sendBotFeedback() : _ctx.sendMessage()), ["prevent"]), ["enter"])),
                  rows: "1"
                }, null, 40, _hoisted_50), [
                  [_vModelText, _ctx.inputText]
                ]),
                _createElementVNode("button", {
                  class: "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300 emoji-button",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojiPicker && _ctx.toggleEmojiPicker(...args)))
                }, _cache[42] || (_cache[42] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "sentiment_satisfied", -1)
                ])),
                (_ctx.showEmojiPicker)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojis, (emoji) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: emoji,
                            onClick: ($event: any) => (_ctx.addEmoji(emoji)),
                            class: "p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-lg transition-colors"
                          }, _toDisplayString(emoji), 9, _hoisted_53))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isBotChat ? _ctx.sendBotFeedback() : _ctx.sendMessage())),
                disabled: _ctx.isUploadingFiles,
                class: "bg-primary-600 text-white h-[50px] px-4 rounded-lg flex items-center justify-center flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed",
                style: {"margin-bottom":"0.3rem"}
              }, [
                (!_ctx.isUploadingFiles)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_55, "send"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[43] || (_cache[43] = [
                      _createElementVNode("div", { class: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" }, null, -1),
                      _createElementVNode("span", { class: "text-sm" }, "מעלה...", -1)
                    ])))
              ], 8, _hoisted_54)
            ])
          ]),
          (_ctx.selectedFiles.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("h4", _hoisted_60, _toDisplayString(_ctx.selectedFiles.length) + " " + _toDisplayString(_ctx.directT('chat.filesSelected')), 1),
                    _createElementVNode("button", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedFiles = [])),
                      class: "text-xs text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
                    }, _toDisplayString(_ctx.directT('chat.clearAll')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFiles, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex items-center justify-between p-2 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600"
                      }, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("i", _hoisted_64, _toDisplayString(_ctx.getFileIcon(file.type)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_65, _toDisplayString(file.name), 1),
                            _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.formatFileSize(file.size)), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.removeFile(index)),
                          class: "text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
                        }, _cache[44] || (_cache[44] = [
                          _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "close", -1)
                        ]), 8, _hoisted_67)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("button", _hoisted_70, [
                _cache[45] || (_cache[45] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "auto_awesome", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('chat.quickReply') || 'Quick Reply') + " ", 1),
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50" }, " Coming Soon ", -1))
              ]),
              _createElementVNode("button", _hoisted_71, [
                _cache[47] || (_cache[47] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "description", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('chat.templates') || 'Templates') + " ", 1),
                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50" }, " Coming Soon ", -1))
              ]),
              _createElementVNode("button", _hoisted_72, [
                _cache[49] || (_cache[49] = _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "person_add", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('chat.transfer') || 'Transfer') + " ", 1),
                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50" }, " Coming Soon ", -1))
              ])
            ])
          ])
        ])
      ])
    ], 2),
    (_ctx.showAddToKnowledgeModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["fixed inset-0 z-50 flex justify-center p-4 md:p-6", {
      'items-start pt-24': _ctx.isMobile.value,
      'items-center': !_ctx.isMobile.value,
      'pb-4': _ctx.isMobile.value
    }])
        }, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/30 backdrop-blur-sm",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeAddToKnowledgeModal && _ctx.closeAddToKnowledgeModal(...args)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["relative bg-white dark:bg-[#0c1427] rounded-2xl w-full shadow-xl transform transition-all overflow-hidden flex flex-col", {
           'max-w-lg max-h-[80vh]': !_ctx.isMobile.value,
           'max-w-full h-full': _ctx.isMobile.value
         }]),
            style: _normalizeStyle(_ctx.modalStyle)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-shrink-0 border-b border-gray-100 dark:border-[#172036]", _ctx.isMobile.value ? 'p-4' : 'p-6']),
              style: {"background":"linear-gradient(135deg, rgb(139, 92, 246), rgb(147, 51, 234))"}
            }, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("img", {
                    src: _ctx.currentBotImage,
                    class: "w-full h-full object-cover"
                  }, null, 8, _hoisted_75)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_76, _toDisplayString(_ctx.directT('chat.botFeedback.addToKnowledge')), 1),
                  (!_ctx.isMobile.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.directT('chat.botFeedback.trainBotDescription')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 overflow-y-auto", _ctx.isMobile.value ? 'p-4' : 'p-6'])
            }, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.directT('chat.botFeedback.originalQuestion')), 1),
                  _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.selectedMessage?.qtext || _ctx.selectedMessage?.text), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.directT('chat.botFeedback.rephraseQuestion')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newKnowledgeQuestion) = $event)),
                    rows: _ctx.isMobile.value ? 3 : 2,
                    class: "w-full bg-gray-50 dark:bg-[#172036] border border-gray-200 dark:border-[#172036] rounded-xl px-4 py-3 text-sm resize-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
                    placeholder: _ctx.directT('chat.botFeedback.rephraseQuestionPlaceholder')
                  }, null, 8, _hoisted_82), [
                    [_vModelText, _ctx.newKnowledgeQuestion]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.directT('chat.botFeedback.newAnswer')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newKnowledgeAnswer) = $event)),
                    rows: _ctx.isMobile.value ? 5 : 4,
                    class: "w-full bg-gray-50 dark:bg-[#172036] border border-gray-200 dark:border-[#172036] rounded-xl px-4 py-3 text-sm resize-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
                    placeholder: _ctx.directT('chat.botFeedback.newAnswerPlaceholder')
                  }, null, 8, _hoisted_84), [
                    [_vModelText, _ctx.newKnowledgeAnswer]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.directT('chat.botFeedback.category')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newKnowledgeCategory) = $event)),
                    class: "w-full bg-gray-50 dark:bg-[#172036] border border-gray-200 dark:border-[#172036] rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  }, [
                    _createElementVNode("option", _hoisted_86, _toDisplayString(_ctx.directT('chat.botFeedback.selectCategory')), 1),
                    _createElementVNode("option", _hoisted_87, _toDisplayString(_ctx.directT('chat.botFeedback.categories.general')), 1),
                    _createElementVNode("option", _hoisted_88, _toDisplayString(_ctx.directT('chat.botFeedback.categories.products')), 1),
                    _createElementVNode("option", _hoisted_89, _toDisplayString(_ctx.directT('chat.botFeedback.categories.services')), 1),
                    _createElementVNode("option", _hoisted_90, _toDisplayString(_ctx.directT('chat.botFeedback.categories.support')), 1),
                    _createElementVNode("option", _hoisted_91, _toDisplayString(_ctx.directT('chat.botFeedback.categories.billing')), 1),
                    _createElementVNode("option", _hoisted_92, _toDisplayString(_ctx.directT('chat.botFeedback.categories.technical')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.newKnowledgeCategory]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.directT('chat.botFeedback.note')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newKnowledgeNote) = $event)),
                    rows: _ctx.isMobile.value ? 3 : 2,
                    class: "w-full bg-gray-50 dark:bg-[#172036] border border-gray-200 dark:border-[#172036] rounded-xl px-4 py-3 text-sm resize-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
                    placeholder: _ctx.directT('chat.botFeedback.notePlaceholder')
                  }, null, 8, _hoisted_94), [
                    [_vModelText, _ctx.newKnowledgeNote]
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-shrink-0 border-t border-gray-100 dark:border-[#172036] flex gap-3", {
             'p-4 flex-col': _ctx.isMobile.value,
             'p-6 justify-between': !_ctx.isMobile.value
           }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeAddToKnowledgeModal && _ctx.closeAddToKnowledgeModal(...args))),
                class: _normalizeClass(["text-sm font-medium rounded-xl transition-all", _ctx.isMobile.value ? 'px-6 py-3 w-full' : 'px-4 py-2']),
                style: {"background":"linear-gradient(135deg, #ef4444 0%, #dc2626 100%)","color":"#ffffff","border":"none"},
                onMouseover: _cache[22] || (_cache[22] = ($event: any) => ($event.target.style.background = 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)')),
                onMouseout: _cache[23] || (_cache[23] = ($event: any) => ($event.target.style.background = 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'))
              }, _toDisplayString(_ctx.directT('chat.botFeedback.cancel')), 35),
              _createElementVNode("button", {
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.submitNewKnowledge && _ctx.submitNewKnowledge(...args))),
                class: _normalizeClass(["text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 rounded-xl transition-all shadow-lg hover:shadow-xl active:scale-95", _ctx.isMobile.value ? 'px-6 py-3 w-full' : 'px-4 py-2'])
              }, _toDisplayString(_ctx.directT('chat.botFeedback.addToKnowledgeBase')), 3)
            ], 2)
          ], 6)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showBotFeedbackModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/30 backdrop-blur-sm",
            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.closeBotFeedback && _ctx.closeBotFeedback(...args)))
          }),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("img", {
                    src: _ctx.currentBotImage,
                    class: "w-full h-full object-cover"
                  }, null, 8, _hoisted_100)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_101, _toDisplayString(_ctx.directT('chat.botFeedback.botFeedbackTitle')), 1),
                  _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.directT('chat.botFeedback.helpImprove')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.directT('chat.botFeedback.selectMessage')), 1),
                _createElementVNode("div", _hoisted_106, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectedBotMessage) = $event)),
                    class: "w-full bg-gray-50 dark:bg-[#172036] border border-gray-200 dark:border-[#172036] rounded-xl px-4 py-2.5 text-sm"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.botMessages, (msg) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: msg.id,
                        value: msg.id
                      }, _toDisplayString(_ctx.truncateMessage(msg.text)), 9, _hoisted_107))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedBotMessage]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.directT('chat.botFeedback.yourFeedback')), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.botFeedbackText) = $event)),
                  rows: "4",
                  class: "w-full bg-gray-50 dark:bg-[#172036] border border-gray-200 dark:border-[#172036] rounded-xl px-4 py-3 text-sm resize-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
                  placeholder: _ctx.directT('chat.botFeedback.feedbackPlaceholder')
                }, null, 8, _hoisted_110), [
                  [_vModelText, _ctx.botFeedbackText]
                ])
              ]),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.directT('chat.botFeedback.rateResponse')), 1),
                _createElementVNode("div", _hoisted_113, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                    return _createElementVNode("button", {
                      key: star,
                      onClick: ($event: any) => (_ctx.botRating = star),
                      class: _normalizeClass(["text-2xl transition-all", star <= _ctx.botRating ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'])
                    }, " ★ ", 10, _hoisted_114)
                  }), 64))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("button", {
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.closeBotFeedback && _ctx.closeBotFeedback(...args))),
                class: "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#172036] rounded-xl transition-all"
              }, _toDisplayString(_ctx.directT('chat.botFeedback.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.submitBotFeedback && _ctx.submitBotFeedback(...args))),
                class: "px-4 py-2 text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 rounded-xl transition-all shadow-lg hover:shadow-xl active:scale-95"
              }, _toDisplayString(_ctx.directT('chat.botFeedback.submitFeedback')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showAssignDropdown)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-[2147483647] flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm",
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showAssignDropdown = false))
          }, [
            _createElementVNode("div", {
              class: "assign-dropdown w-72 bg-white dark:bg-[#0c1427] shadow-2xl rounded-2xl border border-gray-200 dark:border-[#172036] overflow-hidden",
              onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _cache[52] || (_cache[52] = _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center shadow-lg" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-gray-800 dark:text-white text-lg" }, "group")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.directT('chat.botFeedback.assignChat')), 1),
                    _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.directT('chat.botFeedback.selectTeamMember')), 1)
                  ])
                ])
              ]),
              (_ctx.assignedToName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    _createElementVNode("div", _hoisted_121, [
                      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "w-3 h-3 bg-green-500 rounded-full" }, null, -1)),
                      _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.directT('chat.botFeedback.currentlyAssigned')), 1),
                      _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.assignedToName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_124, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgUsers, (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: user.user_id,
                    onClick: ($event: any) => (_ctx.assignToUser(user.user_id)),
                    class: "px-4 py-3 hover:bg-blue-50 dark:hover:bg-blue-900/20 cursor-pointer flex items-center gap-3 group"
                  }, [
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-blue-500 dark:from-blue-500 dark:to-blue-600 flex items-center justify-center group-hover:from-blue-500 group-hover:to-blue-600 shadow-md" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined text-gray-800 dark:text-white text-sm" }, "person")
                    ], -1)),
                    _createElementVNode("div", _hoisted_126, [
                      _createElementVNode("div", _hoisted_127, _toDisplayString(user.display_name), 1),
                      _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.directT('chat.botFeedback.teamMember')), 1)
                    ]),
                    _cache[55] || (_cache[55] = _createElementVNode("i", { class: "material-symbols-outlined text-gray-400 group-hover:text-blue-500 opacity-0 group-hover:opacity-100" }, "arrow_forward", -1))
                  ], 8, _hoisted_125))
                }), 128)),
                (_ctx.assignedToName)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.unassignUser && _ctx.unassignUser(...args))),
                      class: "mx-2 mt-2 px-4 py-3 hover:bg-red-50 dark:hover:bg-red-900/20 cursor-pointer flex items-center gap-3 group border-t border-gray-200 dark:border-[#172036] rounded-lg"
                    }, [
                      _cache[56] || (_cache[56] = _createElementVNode("div", { class: "w-8 h-8 rounded-full bg-gradient-to-r from-red-400 to-red-500 flex items-center justify-center group-hover:from-red-500 group-hover:to-red-600 shadow-md" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined text-gray-800 dark:text-white text-sm" }, "person_remove")
                      ], -1)),
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.directT('chat.botFeedback.unassignChat')), 1),
                        _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.directT('chat.botFeedback.removeAssignment')), 1)
                      ]),
                      _cache[57] || (_cache[57] = _createElementVNode("i", { class: "material-symbols-outlined text-red-400 group-hover:text-red-500 opacity-0 group-hover:opacity-100" }, "close", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}